<template>
  <div class="activeSuccess">
    <section class="page-content">
      <p class="icon">
        <i class="iconfont etc-icon-pakd-check"></i>
      </p>
      <p>激活成功</p>
      <!--<p class="plate" color-primary>粤A·88888</p>-->
      <p class="tip">可前往微信ETC助手小程序查看通行扣费记录</p>
    </section>
    <section class="page-bottom">
      <button cool-btn @click="m_goPages('goETC')">前往ETC助手</button>
      <div class="fixed-bottom"></div>
    </section>
  </div>
</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'

export default {
  name: 'activeSuccess',
  mixins: [FunMixin],
  components: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {
  }
}
</script>

<style scoped lang="scss">
@import "../../style/cool.practical";

.activeSuccess {
  .page-content {
    text-align: center;
    font-size: 32px;
    color: #1e1e1e;
    padding-top: 160px;
    i{
      color: #16c88b;
      font-size: 160px;
    }
    .icon{
      margin-bottom: 28px;
    }
    .plate{
      margin-top: 20px;
      line-height: 42px;
      font-size: 30px;
    }
    .tip{
      font-size: 30px;
      color: #666666;
      margin-top: 20px;
    }
  }
  .page-bottom {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    padding: 30px;
  }
}
</style>
